import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorHandlerInterceptor } from './error-handler.interceptor';
import { SharedModule } from '../shared/shared.module';
import { EnvironmentManager } from './services/environment-manager.service';
import { DataAccess } from './services/data-access.service';
import { BmCache } from './services/bm-cache.service';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HttpClientModule,
    SharedModule,
  ],

  providers: [
    EnvironmentManager,
    DataAccess,
    BmCache,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandlerInterceptor,
      multi: true
    },
  ],

})

export class DataAccessModule {}
